module.exports = __webpack_public_path__ + "img/schema_explication_score.c34b0cd2.jpg";